import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
  creationNouvelleSouscriptionSaga,
  existForfaitAvecMemeExerciceSaga,
  getPackageForSouscriptionSaga,
  getSouscriptionSituationSaga,
} from "./nouvelleSouscriptionSaga";

export default function* nouvelleSouscriptionWatcher() {
  yield takeLatest(
    ActionsTypes.GET_PACKAGE_FOR_SOUSCRIPTION,
    getPackageForSouscriptionSaga
  );
  yield takeLatest(
    ActionsTypes.CREATION_NOUVELLE_SOUSCRIPTION,
    creationNouvelleSouscriptionSaga
  );
  yield takeLatest(
    ActionsTypes.EXIST_FORFAIT_AVEC_MEME_EXERCICE,
    existForfaitAvecMemeExerciceSaga
  );
  yield takeLatest(
      ActionsTypes.GET_SITUATION_FOR_SOUSCRIPTION,
      getSouscriptionSituationSaga
  );
}
